const languagesData = [
	{
		id: 'da',
		title: 'Dansk', 
		shortTitle: 'DA',
		localization: 'da-DK'
	},
	{
		id: 'en',
		title: 'English',
		shortTitle: 'EN',
		localization: 'en-GB'
	}
];

export {languagesData};